<template>
	<div class="wrapper">
		<Navigation :scrollBase="scrollBase" />
		<Landing ref="scrollBase" title="Ajou버스" description="학교 주변에서 이용할 수 있는 교통수단을 알려드립니다." background="https://www.dhnews.co.kr/news/photo/201905/102956_103026_2813.jpg" />
		<div class="container">
			<section class="shuttle">
				<header class="underline underline-inline-block">
					<strong>학교 셔틀버스</strong>	
				</header>
				<table cellpadding="0" cellspacing="0" class="ajou_table" summary="학교버스의 등하교노선을 보여주는 표">
					<caption>
						학교버스 등하교노선</caption>
					<colgroup>
						<col width="8%">
						<col width="20%">
						<col width="27%">
						<col width="6%">
					</colgroup>
					<thead>
						<tr>
							<th rowspan="1" scope="row">
								<p>회차</p>
							</th>
							<th rowspan="1" scope="row">
								<p>출발장소</p>
							</th>
							<th rowspan="1" scope="row">
								<p>학교 승차장 출발시간</p>
								<p>(위치: 도서관옆)</p>
							</th>
							<th colspan="2" rowspan="1" scope="row">
								<p>광교중앙역 출발시간</p>
								<p>(학교행)</p>
							</th>
							<th class="no_right" colspan="1" scope="row">
								<p>운영구분</p>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<th class="noback" scope="col">
								1회</th>
							<td class="noback" rowspan="15">
								<p>광교중앙(아주대)역</p>
								<p>1번 출구</p>
							</td>
							<td>
								<ul class="tri_list04">
									<li>08:22</li>
								</ul>
							</td>
							<td colspan="2">
								<ul class="tri_list04">
									<li>08:30</li>
								</ul>
							</td>
							<td class="no_right">
								학교버스</td>
						</tr>
						<tr>
							<th class="noback" scope="col">
								2회</th>
							<td>
								<ul class="tri_list04">
									<li>08:42</li>
								</ul>
							</td>
							<td colspan="2">
								<ul class="tri_list04">
									<li>08:50</li>
								</ul>
							</td>
							<td class="no_right">
								학교버스</td>
						</tr>
						<tr>
							<th class="noback" scope="col">
								3회</th>
							<td>
								<ul class="tri_list04">
									<li>08:52</li>
								</ul>
							</td>
							<td colspan="2">
								<ul class="tri_list04">
									<li>09:00</li>
								</ul>
							</td>
							<td class="no_right">
								학교버스</td>
						</tr>
						<tr>
							<th class="noback" scope="col">
								4회</th>
							<td>
								09:22</td>
							<td colspan="2">
								09:30</td>
							<td class="no_right">
								학교버스</td>
						</tr>
						<tr>
							<th class="noback" scope="col">
								5회</th>
							<td>
								09:52</td>
							<td colspan="2">
								10:00</td>
							<td class="no_right">
								학교버스</td>
						</tr>
						<tr>
							<th class="noback" scope="col">
								6회</th>
							<td>
								10:07</td>
							<td colspan="2">
								10:15</td>
							<td class="no_right">
								학교버스</td>
						</tr>
						<tr>
							<th class="noback" scope="col">
								7회</th>
							<td>
								10:52</td>
							<td colspan="2">
								11:00</td>
							<td class="no_right">
								학교버스</td>
						</tr>
						<tr>
							<th class="noback" scope="col">
								8회</th>
							<td>
								11:37</td>
							<td colspan="2">
								11:45</td>
							<td class="no_right">
								학교버스</td>
						</tr>
						<tr>
							<th class="noback" scope="col">
								9회</th>
							<td>
								12:52</td>
							<td colspan="2">
								13:00</td>
							<td class="no_right">
								학교버스</td>
						</tr>
						<tr>
							<th class="noback" scope="col">
								10회</th>
							<td>
								13:52</td>
							<td colspan="2">
								14:00</td>
							<td class="no_right">
								학교버스</td>
						</tr>
						<tr>
							<th class="noback" scope="col">
								11회</th>
							<td>
								14:37</td>
							<td colspan="2">
								14:45</td>
							<td class="no_right">
								학교버스</td>
						</tr>
						<tr>
							<th class="noback" scope="col">
								12회</th>
							<td>
								15:52</td>
							<td colspan="2">
								16:00</td>
							<td class="no_right">
								학교버스</td>
						</tr>
						<tr>
							<th class="noback" scope="col">
								13회</th>
							<td>
								16:52</td>
							<td colspan="2">
								17:00</td>
							<td class="no_right">
								학교버스</td>
						</tr>
						<tr>
							<th class="noback" scope="col">
								14회</th>
							<td>
								18:10</td>
							<td colspan="2">
								-</td>
							<td class="no_right">
								학교버스</td>
						</tr>
					</tbody>
				</table>
				<table cellpadding="0" cellspacing="0" class="ajou_table" summary="학교버스의 등하교노선을 보여주는 표">
					<caption>
						학교버스의 등하교노선</caption>
					<colgroup>
						<col width="10%">
						<col width="35%">
						<col width="15%">
						<col width="15%">
						<col width="8%">
						<col>
					</colgroup>
					<thead>
						<tr>
							<th rowspan="2" scope="row">
								노선</th>
							<th rowspan="2" scope="row">
								출발장소</th>
							<th colspan="2" rowspan="2" scope="row">
								출발시간</th>
							<th rowspan="2" scope="row">
								도착시간</th>
							<th class="no_right" colspan="2" rowspan="1" scope="row">
								요금</th>
						</tr>
						<tr>
							<th scope="row">
								승차권</th>
							<th class="no_right" scope="row">
								현금</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<th class="noback" scope="col">
								<p>
									사당역</p>
								<p>
									(등교)</p>
							</th>
							<td class="left_pd">
								<ul class="tri_list02">
									<li>
										이수역(14번 출구)</li>
									<li>
										총신대역(7번 출구)</li>
									<li>
										사당역(4번 출구 홈플러스 앞)</li>
									<li>
										과천(과천주공아파트 6~7단지사이)</li>
								</ul>
							</td>
							<td class="left_pd" colspan="2" rowspan="1">
								<ul class="tri_list02">
									<li>
										07:45</li>
									<li>
										07:48</li>
									<li>
										07:51</li>
									<li>
										07:56</li>
								</ul>
							</td>
							<td>
								08:40</td>
							<td>
								1,300</td>
							<td class="no_right">
								1,500</td>
						</tr>
						<tr>
							<th class="noback" scope="col">
								<p>
									목동</p>
								<p>
									(등교)</p>
							</th>
							<td class="left_pd">
								<ul class="tri_list02">
									<li>
										오목교 (오목교역 1번출구 마을버스 회차지점 앞)</li>
									<li>
										목동오거리 (목동역 7번출구)</li>
								</ul>
							</td>
							<td class="left_pd" colspan="2">
								<ul class="tri_list02">
									<li>
										07:10</li>
									<li>
										07:12</li>
								</ul>
							</td>
							<td>
								08:40</td>
							<td>
								1,300</td>
							<td class="no_right">
								1,500</td>
						</tr>
						<tr>
							<th class="noback" scope="col">
								<p>
									금정역</p>
								<p>
									(등교)</p>
							</th>
							<td class="left_pd">
								<ul class="tri_list02">
									<li>
										금정역(금정농협 맞은편)</li>
									<li>
										1번국도 범계사거리 버스정류장</li>
									<li>
										고천육교 전 기아자동차 대리점 앞</li>
								</ul>
							</td>
							<td class="left_pd" colspan="2">
								<ul class="tri_list02">
									<li>
										07:50</li>
									<li>
										07:58</li>
									<li>
										08:08</li>
								</ul>
							</td>
							<td>
								08:50</td>
							<td>
								1,000</td>
							<td class="no_right">
								1,200</td>
						</tr>
						<tr>
							<th class="noback" scope="col">
								<p>
									잠실</p>
								<p>
									(등교)</p>
							</th>
							<td class="left_pd">
								<ul class="tri_list02">
									<li>
										잠실역 롯데 백화점앞(주공522동 건너편)</li>
									<li>
										가락시장 신 동문 앞</li>
									<li>
										복정역 3번출구(완불주유소) 앞</li>
								</ul>
							</td>
							<td class="left_pd" colspan="2">
								<ul class="tri_list02">
									<li>
										07:40</li>
									<li>
										07:45</li>
									<li>
										07:58</li>
								</ul>
							</td>
							<td>
								08:40</td>
							<td>
								1,300</td>
							<td class="no_right">
								1,500</td>
						</tr>
						<tr>
							<th class="noback" scope="col">
								<p>
									안산</p>
								<p>
									(등교)</p>
							</th>
							<td class="left_pd">
								<ul class="tri_list02">
									<li>
										안산역 롯데리아 앞 통근버스승강장</li>
									<li>
										중앙역앞 시내버스정류장</li>
									<li>
										한대앞역 1번출구 앞</li>
									<li>
										상록수역 길건너 통근버스승강장</li>
								</ul>
							</td>
							<td class="left_pd" colspan="2">
								<ul class="tri_list02">
									<li>
										07:30</li>
									<li>
										07:37</li>
									<li>
										07:42</li>
									<li>
										07:47</li>
								</ul>
							</td>
							<td>
								08:40</td>
							<td>
								1,000</td>
							<td class="no_right">
								1,200</td>
						</tr>
						<tr>
							<th class="noback" scope="col">
								<p>
									분당/정자역</p>
								<p>
									(등교)</p>
							</th>
							<td class="left_pd">
								<ul class="tri_list02">
									<li>
										정자역 5번출구</li>
									<li>
										미금역 7번출구</li>
								</ul>
							</td>
							<td class="left_pd" colspan="2">
								<ul class="tri_list02">
									<li>
										08:05</li>
								</ul>
							</td>
							<td>
								&nbsp;</td>
							<td>
								1,000</td>
							<td class="no_right">
								1,200</td>
						</tr>
						<tr>
							<th class="noback" scope="col">
								<p>
									수원역</p>
								<p>
									(등·하교)</p>
							</th>
							<td class="left_pd">
								<ul class="tri_list02">
									<li>
										수원역 로터리 9번/10번 출구 사이 학생버스 승강장</li>
								</ul>
							</td>
							<td class="left_pd" colspan="2">
								<ul class="tri_list02">
									<li>
										주간 수시운행<br> 수원역 ↔ 학교</li>
									<li>
										오전(수원역)<br> 08:15 / 08:20 / 09:30 / 10:30 / 11:30</li>
									<li>
										오후(학교)<br> 15:00 / 16:00 / 17:00 / 18:10</li>
								</ul>
							</td>
							<td>
								&nbsp;</td>
							<td class="no_right" colspan="2" rowspan="1">
								무료운행</td>
						</tr>
						<tr>
							<th class="noback" scope="col">
								하교</th>
							<td class="left_pd">
								<ul class="tri_list02">
									<li>
										율곡관 출발버스: 수원역 / 광교중앙역</li>
									<li>
										<u>그 외의 노선은 하교차량 없음</u></li>
								</ul>
							</td>
							<td class="left_pd" colspan="2">
								<ul class="tri_list02">
									<li>
										18:10</li>
								</ul>
							</td>
							<td>
								&nbsp;</td>
							<td class="no_right" colspan="2" rowspan="1">
								&nbsp;</td>
						</tr>
					</tbody>
				</table>
				<table cellpadding="0" cellspacing="0" class="ajou_table" summary="학교버스의 등하교노선을 보여주는 표">
					<caption>
						학교버스 등하교노선</caption>
					<colgroup>
						<col width="22%">
						<col width="22%">
						<col width="22%">
					</colgroup>
					<thead>
						<tr>
							<th colspan="3" rowspan="1" scope="row">
								<p>
									광교중앙역 출발 → 아주대학교 경유 → 지동시장</p>
							</th>
							<th class="no_right" colspan="2" rowspan="1" scope="row">
								<p>
									비고</p>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<th class="noback" scope="col">
								06:00</th>
							<td>
								11:44</td>
							<td>
								17:09</td>
							<td class="no_right" colspan="2" rowspan="16">
								<p style="text-align: left;">
									1. 좌측 시간표는 광교중앙역 출발시간입니다.</p>
								<p style="text-align: left;">
									2. 아주대 도서관 앞 도착 소요시간(약 10분 소요)</p>
							</td>
						</tr>
						<tr>
							<th class="noback" scope="col">
								06:19</th>
							<td>
								12:03</td>
							<td>
								17:28</td>
						</tr>
						<tr>
							<th class="noback" scope="col">
								06:38</th>
							<td>
								12:22</td>
							<td>
								17:47</td>
						</tr>
						<tr>
							<th class="noback" scope="col">
								06:57</th>
							<td>
								12:41</td>
							<td>
								18:06</td>
						</tr>
						<tr>
							<th class="noback" scope="col">
								07:16</th>
							<td>
								13:00</td>
							<td>
								18:25</td>
						</tr>
						<tr>
							<th class="noback" scope="col">
								07:35</th>
							<td>
								13:19</td>
							<td>
								18:44</td>
						</tr>
						<tr>
							<th class="noback" scope="col">
								07:54</th>
							<td>
								13:38</td>
							<td>
								19:03</td>
						</tr>
						<tr>
							<th class="noback" scope="col">
								08:13</th>
							<td>
								13:57</td>
							<td>
								19:28</td>
						</tr>
						<tr>
							<th class="noback" scope="col">
								08:32</th>
							<td>
								14:16</td>
							<td>
								19:56</td>
						</tr>
						<tr>
							<th class="noback" scope="col">
								08:51</th>
							<td>
								14:35</td>
							<td>
								20:21</td>
						</tr>
						<tr>
							<th class="noback" scope="col">
								09:10</th>
							<td>
								14:54</td>
							<td>
								20:46</td>
						</tr>
						<tr>
							<th class="noback" scope="col">
								09:29</th>
							<td>
								15:13</td>
							<td>
								21:11</td>
						</tr>
						<tr>
							<th class="noback" scope="col">
								10:00</th>
							<td>
								15:45</td>
							<td>
								21:36</td>
						</tr>
						<tr>
							<th class="noback" scope="col">
								10:30</th>
							<td>
								16:15</td>
							<td>
								21:51</td>
						</tr>
						<tr>
							<th class="noback" scope="col">
								11:00</th>
							<td>
								16:45</td>
							<td>
								22:30</td>
						</tr>
						<tr>
							<th class="noback" scope="col">
								11:25</th>
							<td colspan="2" rowspan="1">
								&nbsp;</td>
						</tr>
					</tbody>
				</table>
			</section>
			<section class="ord-bus">
				<header class="underline underline-inline-block">
					<strong>일반 시내/광역/마을버스</strong>
				</header>
				<div id="map"></div>
			</section>
		</div>
		<Footer />
	</div>
</template>

<script>
import axios from 'axios'
import Navigation from '@/components/Navigation.vue'
import Landing from '@/components/Landing.vue'
import Footer from '@/components/Footer.vue'
export default {
	components: {
		Navigation,
		Landing,
		Footer
	},
	data() {
		return {
			scrollBase: null,
			apiCallback: 'https://map.kakao.com/bus/stop.json?busstopid=',
			stops: ['BS72693', 'BS72549', 'BS72694', 'BS72548', 'BS320880', 'BS320876', 'BS320881'],
			stopsInfo: []
		}
	},
	methods: {

	},
	mounted() {
		this.scrollBase = this.$refs.scrollBase.$el.getBoundingClientRect().bottom / 3
		let kakaoMap = document.createElement('script')
		kakaoMap.setAttribute('src', '//dapi.kakao.com/v2/maps/sdk.js?appkey=57ca092a89b95b1726db4a29813a43c5&autoload=false')
		document.body.appendChild(kakaoMap)
	}
}
</script>

<style lang="scss">
#map {
	width: 100vw;
	height: 400px;
}
</style>